// config.ts
import { Config } from "@adornis/config/config.js";
var fileConfig = new Config("file-config", {
  baseURL: { client: true, defaultVal: "/api/file", env: true, name: "FILES_EXPRESS_BASE_URL", required: false },
  datadir: { client: false, defaultVal: "/datadir", env: true, name: "DATADIR", required: false },
  tempDatadir: { client: false, defaultVal: "/datadir/tmp", env: true, name: "TEMP_DATADIR", required: false }
});
export {
  fileConfig
};
